import QUERY from '@/api_app/CustomerMessage'
import { Toast } from 'vant';

const getDefaultState = () => {
  return {
    offset: 1,
    getMessagelist: {},
    getMessageDetail: {},
    SearchData: {},
    twoTitle: {},
    messageListLength: 0,
    scrollTopValue: 0
  }
}

const state = getDefaultState()

const mutations = {
  SET_DATA: (state, { key, data }) => {
    state[key] = data;
  },
  offset_set: (state, data)=>{
    state['offset'] = data
  },
  clear_SearchData: (state,data)=>{
    state['SearchData'] = {}
  },
  messageListLength: (state,data)=>{
    state['messageListLength'] = data
  }
}

const actions = {
  // 小程序客户消息-列表数据
  getMessagelist({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'getMessagelist', params }).then(response => {
        const { data } = response

        if (data.code != 1000) {
          Toast(data.message)
        } else {
            commit('messageListLength', { key: 'messageListLength', data: state.messageListLength+=1 })

          let getMessagelist = state.getMessagelist || {}
          if (params.offset == 1) {
            getMessagelist = data.data
          } else {
            getMessagelist.list = getMessagelist.list.concat(data.data.list)
          }
          commit('SET_DATA', { key: 'getMessagelist', data: getMessagelist })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 小程序客户消息-客户消息对话框详情
  getMessageDetail({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'getMessageDetail', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        } else {
          let getMessageDetail = state.getMessageDetail || {}
          if (params.offset == 1) {
            getMessageDetail = data.data
          } else {
            getMessageDetail.list = data.data.list.concat(getMessageDetail.list)
          }
          commit('SET_DATA', { key: 'getMessageDetail', data: getMessageDetail })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 小程序客户消息-客户消息对话框详情
  SearchData({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'getMessagelist', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        } else {
          commit('SET_DATA', { key: 'SearchData', data: data.data.list })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

